import moment from 'moment';

export default class SchoolYear {

    constructor(kindergartenId) {
        this.name = '';
        this.kindergartenId = kindergartenId;
    }
    
    static fromData(data) {
        if (!data) {
            return;
        }

        let schoolYear = new SchoolYear();
        schoolYear.id = data.id;
        schoolYear.name = data.name;
        schoolYear.start = moment(data.start);
        schoolYear.end = moment(data.end);
        schoolYear.kindergartenId = data.kindergarten_id;
        schoolYear.immutableDate = moment(data.immutable_date);
        
        schoolYear.isDeletable = data.is_deletable;
        schoolYear.isEditable = data.is_editable;

        Object.seal(schoolYear);
        return schoolYear;
    }

    toData() {
        return {
            id: this.id,
            kindergartenId: this.kindergartenId,
            name: this.name,
            start: this.start.format('DD.MM.YYYY'),
            end: this.end.format('DD.MM.YYYY'),
            immutableDate: this.immutableDate.format('DD.MM.YYYY'),
        };
    }

    isEmpty() {
        return !this.start && !this.end && !this.name && !this.id && !this.immutableDate;
    }

    isValid() {
        if (!this.name) {
            return false;
        }

        if (!this.start) {
            return false;
        }        
        
        if (!this.immutableDate || moment(this.immutableDate, 'DD.MM.YYYY') > moment(this.end, 'DD.MM.YYYY') || moment(this.immutableDate, 'DD.MM.YYYY') < moment(this.start, 'DD.MM.YYYY')) {
            return false;
        }

        if (!this.end || moment(this.start, 'DD.MM.YYYY') > moment(this.end, 'DD.MM.YYYY')) {
            return false;
        }

        return true;
    }
}
